/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash-es/_freeGlobal.js
// module id = 92
// module chunks = 0


// WEBPACK FOOTER //
// node_modules/lodash-es/_freeGlobal.js